import { rawAxios as axios } from "./axios";
import { api } from "./axios.config";

// const API_URL = api.manageApiUrl;

const API_URL = api.apiUrl;

const GET_COMMUNITY = "/community";

export function getCommunityDetails(communityUrl = "") {
	return axios.get(API_URL + GET_COMMUNITY + `/${communityUrl}`);
}

export function getCommunityEvents(
	communityUrl = "",
	eventStatus = "ongoing",
	searchTerm = "",
	limit = 8,
	offset = 0
) {
	let QUERY = `/${communityUrl}/events?event_status=${eventStatus}&limit=${limit}&offset=${offset}${searchTerm.length ? `&search_term=${searchTerm}` : ""}`;
	return axios.get(API_URL + GET_COMMUNITY + QUERY);
}
